import { render, staticRenderFns } from "./ImageComp.vue?vue&type=template&id=192415a5&"
import script from "./ImageComp.vue?vue&type=script&lang=js&"
export * from "./ImageComp.vue?vue&type=script&lang=js&"
import style0 from "./ImageComp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports